module.exports = __webpack_public_path__ + "static/media/tło4.a6259926.png";